<!--
 * @Description: 首页 -- PC端
-->

<template>
	<main class="pc-index">
		<Energy />
		<Masters />
		<LazyMount>
			<section class="pc-center-1200">
				<TeacherConsultation />
				<FameTeacher />
				<TopTeacher />
				<More />
			</section>
			<Privilege />
		</LazyMount>
	</main>
</template>

<script setup>
import { defineAsyncComponent, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { logEvent } from "~/utils/firebase";
import { useUserStore } from "~/stores/user";
import usePixel from "~/hooks/usePixel";
import Energy from "./components/energy/index.vue";
import Masters from "./components/masters/index.vue";
import LazyMount from "../components/lazy-mount/index.vue";

const TeacherConsultation = defineAsyncComponent(
	() => import("./components/teacher-consultation/index.vue")
);
const FameTeacher = defineAsyncComponent(() => import("./components/fame-teacher/index.vue"));
const TopTeacher = defineAsyncComponent(() => import("./components/top-teacher/index.vue"));
const More = defineAsyncComponent(() => import("./components/more/index.vue"));
const Privilege = defineAsyncComponent(() => import("./components/privilege/index.vue"));

const { isLogin } = storeToRefs(useUserStore());
const { reportGooglePixelEvent } = usePixel();

const isPageReload = () => {
	if (!import.meta.client) return false;
	const navigation = performance.getEntriesByType("navigation")?.[0];
	return navigation?.type === "reload";
};

onMounted(async () => {
	if (isPageReload()) {
		await refreshNuxtData();
	}

	try {
		logEvent("seeronnet_home_show");
		reportGooglePixelEvent("gw_index_page_view");
	} catch (error) {
		console.error("埋点事件发送失败:", error);
	}
});
</script>

<style lang="scss" scoped>
.pc-index {
	background: #ffffff;
	min-width: 0;
	overflow-x: clip;

	:deep(.pc-center-1360) {
		width: 100%;
		max-width: 1360px;
		padding-inline: clamp(16px, 2vw, 24px);
		margin-inline: auto;
		box-sizing: border-box;
	}

	.pc-center-1360 {
		overflow: hidden;
	}

	@media (max-width: 1200px) {
		:deep(.pc-energy .energy-content) {
			flex-direction: column;
		}

		:deep(.pc-masters .guide) {
			right: clamp(24px, 8vw, 200px);
		}

		:deep(.fame-teacher .box1) {
			flex-direction: column;
		}

		:deep(.fame-teacher .left),
		:deep(.fame-teacher .right) {
			flex: 1 1 auto;
			width: 100%;
		}

		:deep(.top-teacher .teacher-panel) {
			flex-direction: column;
		}

		:deep(.top-teacher .teacher-panel__profile) {
			flex: 1 1 auto;
			width: 100%;
		}

		:deep(.top-teacher .teacher-panel__video-grid) {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		:deep(.more .ai-tool-grid) {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 20px 24px;
		}

		:deep(.more .tool-list) {
			gap: 24px;
		}

		:deep(.privilege__body) {
			flex-direction: column;
			align-items: stretch;
		}

		:deep(.privilege__right) {
			width: 100%;
		}
	}

	@media (max-width: 992px) {
		:deep(.pc-masters) {
			height: auto;
			min-height: 640px;
			margin-top: 60px;
		}

		:deep(.more .tool-list) {
			flex-wrap: wrap;
		}

		:deep(.more .tool-card) {
			flex: 1 1 calc(50% - 12px);
			min-width: min(100%, 320px);
		}

		:deep(.more .tool-card__button) {
			width: 100%;
			max-width: 319px;
		}
	}
}
</style>
